export const servicesData = [
  {
    slug: 'small-group-workouts',
    icon: 'Users',
    title: 'Small Group Workouts',
    shortDescription: 'Intensive skill development in small groups. Minimum 2 and maximum 12 players per session for personalized attention and competitive training environment.',
    heroTagline: 'Premium Training. Small Group. Big Results.',
    overview: 'Our Small Group Workouts are the gold standard in personalized basketball training. With a minimum of 2 and maximum of 12 players per session, you get the focused attention of a private lesson combined with the competitive energy of training alongside other elite players.',
    features: [
      {
        title: 'Minimum 2 / Maximum 12',
        description: 'Personalized coaching attention while maintaining a competitive training environment.'
      },
      {
        title: 'Position-Specific Training',
        description: 'Drills and concepts tailored to your position and role on the court.'
      },
      {
        title: 'Live Game Application',
        description: 'Every drill connects to real game situations you face every night.'
      },
      {
        title: 'Skill Progression Tracking',
        description: 'Measurable improvement through structured progression and benchmarks.'
      }
    ],
    whatToExpect: [
      'Dynamic warm-up and movement preparation',
      'Position-specific skill development blocks',
      'Live-action drill work with defensive pressure',
      'Game-situation scenarios and decision making',
      'Individual feedback and film reference points'
    ],
    idealFor: 'High school, college, and professional players committed to leveling up. Players who want personalized coaching without sacrificing competitive intensity.',
    cta: {
      primary: 'Request Info on Small Groups'
    }
  },
  {
    slug: 'academies',
    icon: 'GraduationCap',
    title: 'Academies',
    shortDescription: 'Multi-day training academies focused on specific skills. Shooting, ball-handling, footwork, and game IQ development programs.',
    heroTagline: 'Master One Thing. Master Your Game.',
    overview: 'Academies are intensive multi-day programs designed to develop mastery in a specific area of your game. From shooting mechanics to ball-handling under pressure, each academy delivers deep, focused training that creates real, measurable improvement.',
    features: [
      {
        title: 'Multi-Day Intensive Format',
        description: 'Deep focus on one skill area over 2-5 days for true mastery, not surface-level exposure.'
      },
      {
        title: 'Mechanics + Application',
        description: 'Break down the fundamentals, then apply them under game-speed conditions.'
      },
      {
        title: 'Video Analysis Included',
        description: 'Daily film review of your reps so you can see what coaches see.'
      },
      {
        title: 'Take-Home Training Plan',
        description: 'Leave with a customized continuation plan to maintain your gains.'
      }
    ],
    whatToExpect: [
      'Comprehensive skill assessment on day one',
      'Daily progression building from fundamentals to advanced',
      'Position-specific application sessions',
      'Competitive scrimmage situations',
      'Take-home workout program and film review'
    ],
    idealFor: 'Serious athletes ready to commit several days to mastering a specific skill area. Players looking for breakthrough improvement, not incremental progress.',
    cta: {
      primary: 'View Academies'
    }
  },
  {
    slug: 'team-camps-clinics',
    icon: 'Target',
    title: 'Team Camps & Clinics',
    shortDescription: 'Customized team training and skill clinics. Build team chemistry, learn system concepts, and elevate your program.',
    heroTagline: 'Elevate Your Entire Program.',
    overview: 'Bring NBA-level training directly to your team. Whether you need pre-season skill development, in-season tune-ups, or off-season program building, our Team Camps & Clinics are customized to your team\'s specific needs and goals.',
    features: [
      {
        title: 'Fully Customized Content',
        description: 'Built around your team\'s system, weaknesses, and competitive goals.'
      },
      {
        title: 'Coach Collaboration',
        description: 'Direct partnership with your coaching staff to reinforce your existing system.'
      },
      {
        title: 'Position Groups + Full Team',
        description: 'Break out by position for specialized work, then come together as a unit.'
      },
      {
        title: 'Player Development Plans',
        description: 'Individual development roadmaps for every player on your roster.'
      }
    ],
    whatToExpect: [
      'Pre-camp planning call with head coach',
      'Customized practice plans and skill progressions',
      'Individual and group skill development',
      'Team concept and system reinforcement',
      'Post-camp report with recommendations for continued development'
    ],
    idealFor: 'High school, AAU, college programs, and professional teams. Coaches who want to invest in their program\'s long-term development with proven training methodology.',
    featuredClinic: {
      name: 'Youth Skills Clinic',
      date: 'TBA',
      focus: 'Gaining confidence with contested finishing and decision making attacking the paint.'
    },
    cta: {
      primary: 'Book Your Team'
    }
  },
  {
    slug: 'team-consulting',
    icon: 'Briefcase',
    title: 'Team Consulting',
    shortDescription: 'Strategic consulting for coaches and programs. Skill development systems, practice planning, and player development strategies.',
    heroTagline: 'Build A Program That Lasts.',
    overview: 'Team Consulting is a strategic partnership designed for coaches and programs who are committed to building championship-level player development infrastructure. From practice planning to long-term program building, we help you systematize excellence.',
    features: [
      {
        title: 'Program Audit + Strategy',
        description: 'Comprehensive review of your current system with strategic recommendations.'
      },
      {
        title: 'Practice Planning Templates',
        description: 'NBA-level practice planning frameworks adaptable to your level.'
      },
      {
        title: 'Player Development Systems',
        description: 'Build position-specific, age-appropriate development tracks.'
      },
      {
        title: 'Ongoing Advisory Support',
        description: 'Direct line for in-season decision making and program adjustments.'
      }
    ],
    whatToExpect: [
      'Initial strategy session to understand your program',
      'Customized development framework delivered in writing',
      'Practice plan templates and player evaluation tools',
      'Quarterly check-ins to refine and adjust',
      'On-call advisory access for in-season decisions'
    ],
    idealFor: 'Head coaches, program directors, and athletic departments building long-term competitive programs. Leaders who want to invest in systems, not just sessions.',
    cta: {
      primary: 'Schedule Consultation'
    }
  }
];

export const getServiceBySlug = (slug) => servicesData.find(s => s.slug === slug);
